/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/camelcase */
import { IJsonQuery } from '@cian/api-models/common/json_query';
import { FOfferType } from '../../../utils/offer_type';
import { getAreaMeasure } from './getAreaMeasure';
import { getPrettyNumber } from './getPrettyNumber';
import { getOfferType } from './jsonQuery';

/**
 * Принимает jsonQuery, в нём находит параметры площади (total_area или site) и
 * запускает для них генератор текста.
 */
export function getAreaText(jsonQuery: IJsonQuery): string {
  const { total_area, site } = jsonQuery;
  const offerType = getOfferType(jsonQuery);

  if (total_area) {
    const {
      value: { gte, lte },
    } = total_area;

    return getText(offerType, gte, lte);
  } else if (site) {
    const {
      value: { gte, lte },
    } = site;

    return getText(offerType, gte, lte);
  } else {
    return '';
  }
}

/**
 * Генерирует текст площади.
 */
export function getText(offerType: FOfferType, gte?: number, lte?: number): string {
  const nbsp = '\u00A0';
  const areaMeasure = getAreaMeasure(offerType);

  switch (true) {
    case gte !== undefined && gte < 1 && lte !== undefined:
      // tslint:disable-next-line:no-non-null-assertion
      return `до ${getPrettyNumber(lte!, '', nbsp)}${nbsp}${areaMeasure}`;
    case gte !== undefined && lte !== undefined:
      // tslint:disable-next-line:no-non-null-assertion
      return (
        // tslint:disable-next-line:no-non-null-assertion
        `от ${getPrettyNumber(gte!, '', nbsp)}${nbsp}${areaMeasure} до ` +
        // tslint:disable-next-line:no-non-null-assertion
        `${getPrettyNumber(lte!, '', nbsp)}${nbsp}${areaMeasure}`
      );
    case gte !== undefined:
      // tslint:disable-next-line:no-non-null-assertion
      return `от ${getPrettyNumber(gte!, '', nbsp)}${nbsp}${areaMeasure}`;
    case lte !== undefined:
      // tslint:disable-next-line:no-non-null-assertion
      return `до ${getPrettyNumber(lte!, '', nbsp)}${nbsp}${areaMeasure}`;
    default:
      return '';
  }
}
